import React from 'react';

const Error = () => (<h2>Page not found</h2>)

export default Error;